import Image from 'next/image'
import styled from 'styled-components'
import rentersIcon from '../../../assets/ai-studio-landing/renters.png'
import homeownersIcon from '../../../assets/ai-studio-landing/honeowners.png'
import diyIcon from '../../../assets/ai-studio-landing/diy.png'
import enthusiastsIcon from '../../../assets/ai-studio-landing/enthousiasts.png'

const SectionWrapper = styled.section`
  width: 100%;
  padding: 80px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`

const SectionTitle = styled.h2`
  color: black;
  font-size: 48px;
  font-weight: 500;
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`

const SectionSubtitle = styled.p`
  color: #3F3F3F;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin: 0;
  max-width: 1000px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  width: 100%;
  max-width: 1200px;
  margin-top: 26px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

const AudienceCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;

  @media (max-width: 600px) {
    flex-direction: row;
    text-align: left;
    gap: 16px;
  }
`

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const IconWrapper = styled.div`
  width: 72px;
  height: 72px;
  position: relative;
  flex-shrink: 0;
  margin-bottom: 6px;

  @media (max-width: 600px) {
    margin-bottom: 0;
    width: 56px;
    height: 56px;
  }
`

const CardTitle = styled.h3`
  color: black;
  font-size: 24px;
  font-weight: 500;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`

const CardDescription = styled.p`
  color: #545454;
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const audienceData = [
  {
    icon: rentersIcon,
    title: 'Renters & Small Spaces',
    description: 'Design apartments and small rooms with AI — experiment with layouts, furniture, colors, and décor without making permanent changes.'
  },
  {
    icon: homeownersIcon,
    title: 'Homeowners',
    description: 'Plan and visualize interior design for your home before buying furniture, renovating, or committing to major design decisions.'
  },
  {
    icon: diyIcon,
    title: 'DIY Decorators',
    description: 'Explore interior design ideas, test styles, swap décor, and refine details with AI to bring your vision to life.'
  },
  {
    icon: enthusiastsIcon,
    title: 'Design Enthusiasts',
    description: 'Create, iterate, and experiment with AI interior design tools to generate polished, realistic room designs at scale.'
  }
]

const MadeForEveryHomeSection = () => {
  return (
    <SectionWrapper>
      <SectionTitle>Made for Every Kind of Home.</SectionTitle>
      <SectionSubtitle>
        Built for real homes and real people. Whether you're designing a small apartment, a rental, or a full house, our AI interior design tools adapt to your space, style, and budget — no experience needed.
      </SectionSubtitle>

      <CardsContainer>
        {audienceData.map((item, index) => (
          <AudienceCard key={index}>
            <IconWrapper>
              <Image
                src={item.icon}
                alt={item.title}
                width={72}
                height={72}
              />
            </IconWrapper>
            <TextContent>
              <CardTitle>{item.title}</CardTitle>
              <CardDescription>{item.description}</CardDescription>
            </TextContent>
          </AudienceCard>
        ))}
      </CardsContainer>
    </SectionWrapper>
  )
}

export default MadeForEveryHomeSection
